<template>
  <v-menu :close-on-content-click="false" offset-x v-model="show">
    <template v-slot:activator="{ on }">
      <v-list-item
        link
        @click="show = true"
        @dblclick="setResourceViewer({ show: true, resourceId: research.id })"
      >
        <v-list-item-icon>
          <v-img
            width="24"
            contain
            :src="research.resourceData.thumbnailUrl || research.resourceData.image"
          ></v-img>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ research.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <resource-details-card :resource="research" showOpen>
      <template v-slow>
        <v-btn
          style="position: absolute; top: 3px; right: 3px;"
          elevation="0"
          fab
          x-small
          @click.native="show = false"
          ><v-icon>close</v-icon></v-btn
        >
      </template>
    </resource-details-card>
  </v-menu>
</template>

<script>
import ResourceDetailsCard from '@/components/Resources/ResourceDetailsCard';
import { mapMutations } from 'vuex';
export default {
  props: ['research'],
  components: { ResourceDetailsCard },
  data() {
    return {
      show: false
    };
  },
  computed: {},
  methods: {
    ...mapMutations('views/context', ['setResourceViewer'])
  }
};
</script>

<style></style>
